import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import { 
  getAllUsers as getAllUsersApi,
 } from "../../helpers/custom_helper/backend_helper"

export const getUserListThunk = createAsyncThunk( "get-all-users",async (data, { rejectWithValue }) => {
    try {
      
      const response = await getAllUsersApi(data);
      if (response.success) {
        return response;
      } else {
        toast.error(response.message || "Data failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);






